<template>
    <div>
        <div v-if="show">
            <div v-if="plan_config&&unit" class="plan-content">
                <v-card flat v-if="display_option.show_title" class="my-5">
                    <div class="plan-title row d-flex pa-2">
                        <div class="col-12 col-sm-6 py-0 plan-logo">
                            <v-img
                                    v-if="plan_config.ImagePath.indexOf('http') == -1"
                                    alt="plan logo"
                                    :src="'http://rmis.lpn.co.th/modules/sale_plan/assets/images/'+plan_config.ImagePath"
                                    max-height="100"
                                    contain
                            />
                            <v-img
                                    v-else
                                    alt="plan logo"
                                    :src="plan_config.ImagePath"
                                    :lazy-src="plan_config.ImagePath"
                                   max-height="100"
                                   contain
                            >
                                <template v-slot:placeholder>
                                    <v-row
                                            class="fill-height ma-0"
                                            align="center"
                                            justify="center"
                                    >
                                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                    </v-row>
                                </template>
                            </v-img>
                        </div>
                        <div class="col-12 col-sm-6 plan-name d-flex align-center justify-center flex-fill">
                            <h3>{{ plan_config.pj_name }}</h3>
                        </div>
                    </div>
                </v-card>

                <div v-if="stock_mapping" class="plan-table-div">

                    <v-card flat class="my-5">
                        <v-card-text>
                            <label class="blue--text">คำอธิบาย</label>
                            <p class="mt-2 mb-0">ขนาดห้อง</p>
                            <v-row class="row--dense">
                                <v-col v-for="(desc, desc_index) in size_color"
                                       :key="'desc_'+desc_index"
                                       class="col text-center"
                                       :style="'background:'+desc[0]+';border:1px solid #f0f0f0;'"
                                >
                                    {{ desc[1] }}
                                </v-col>
                            </v-row>
                            <p class="mt-2 mb-0">ระดับความสนใจ</p>
                            <v-row class="row--dense">
                                <v-col v-for="(hot, hot_index) in hot_color"
                                       :key="'hot_'+hot_index"
                                       class="col text-center"
                                       :style="'background:'+hot.color_code+';border:1px solid #f0f0f0;color:'+hot.color_text+';'"
                                >
                                    {{ hot.order }}
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>

                    <v-card flat class="my-5">
                        <v-card-text>
                            <label class="blue--text">ตั้งค่าการแสดงผล</label>
                            <v-row>
                                <v-col cols="12" class="py-0">
                                    <p class="mt-2 mb-0">เลือกอาคาร</p>
                                    <v-row class="row--dense">
                                        <template v-for="(bd, bd_index) in building_config">
<!--                                            <v-col v-if="bd_index==0" class="col text-center ma-1 select_building"-->
<!--                                                   @click="setSelectedBuilding()"-->
<!--                                                   :style="'background:#ccc;'+(!selected_building ? 'background:#16448f !important;color:#fff;':'')"-->
<!--                                            >-->
<!--                                                ทั้งหมด-->
<!--                                            </v-col>-->
                                            <v-col class="col text-center ma-1 select_building"
                                                   @click="setSelectedBuilding(bd)"
                                                   :style="'background:#ccc;'+(selected_building&&bd.bd_runno==selected_building.bd_runno ? 'background:#16448f !important;color:#fff;':'')"
                                            >
                                                {{ bd.bd_name }}
                                            </v-col>
                                        </template>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" class="mt-5 py-0">
                                    <v-slider
                                            v-model="planStyle_zoom"
                                            append-icon="mdi-magnify-plus-outline"
                                            prepend-icon="mdi-magnify-minus-outline"
                                            min="0.2"
                                            max="2"
                                            step="0.01"
                                            @click:append="zoomIn"
                                            @click:prepend="zoomOut"
                                            class="zoom_tool"
                                            :style="toolStyle"
                                    ></v-slider>
                                </v-col>
        <!--                    <v-btn class="float-right" @click="renderPlanAsImage('plan_all')">แสดงภาพรวม</v-btn>-->
                            </v-row>
                        </v-card-text>
                    </v-card>

                    <div id="plan_all" class="mt-5">
                            <template v-if="selected_building">
                                <div class="plan-building-name d-flex align-center">

                                    <h2 class="bd_name_text">อาคาร {{ selected_building.bd_name }}</h2>

                                    <v-row class="row row--dense bd_name_select fill-height d-none">
<!--                                        <v-col class="col text-center blue white&#45;&#45;text">-->
<!--                                            <v-icon @click="switchPlanMode('table',project_id)"  color="white">mdi-table</v-icon>-->
<!--                                        </v-col>-->
                                        <v-col class="blue white--text">อาคาร</v-col>
                                        <template v-for="(bd, bd_index2) in building_config">
                                            <v-col class="col text-center select_building"
                                                   @click="setSelectedBuilding(bd)"
                                                   :style="'background:#ccc;'+(selected_building&&bd.bd_runno==selected_building.bd_runno ? 'background:#ffcc80 !important;color:#555;':'')"
                                            >
                                                {{ bd.bd_name }}
                                            </v-col>
                                        </template>
                                    </v-row>
<!--                                    <span class="ml-2">{{ selected_floor&&parseInt(selected_floor)==13 ? 'ชั้น 12A':'ชั้น '+selected_floor}}</span>-->
                                </div>

                                <div
                                    class="plan-table-detail mx-n3 mt-5"
                                     :style="'min-height:'+(original_plan_img_size ? original_plan_img_size.height:'800')+'px;'"
                                >
                                    <div class="select_floor">
                                        <div class="text-center scrollable" @click="scrollFloor('up')">
                                            <v-icon>mdi-menu-up</v-icon>
                                        </div>
                                        <v-card class="elevation-10">
                                            <div class="blue white--text text-center">ชั้น</div>
                                            <v-divider></v-divider>
                                            <div class="floor_number">
                                                <template v-for="(fl, fl_index) in parseInt(selected_building.max_floor)">

                                                    <v-col
                                                            cols="12"

                                                            v-if="(!JSON.parse(selected_building.floor_skip)||!JSON.parse(selected_building.floor_skip).includes((parseInt(selected_building.max_floor)-fl)+1))&&(parseInt(selected_building.floor_start)<=((parseInt(selected_building.max_floor)-fl)+1))"

                                                            @click="setSelectedFloor(((parseInt(selected_building.max_floor)-fl)+1)>9 ? ((parseInt(selected_building.max_floor)-fl)+1):'0'+((parseInt(selected_building.max_floor)-fl)+1))"

                                                            :class="(selected_floor&&selected_floor==(((parseInt(selected_building.max_floor)-fl)+1)>9 ? ((parseInt(selected_building.max_floor)-fl)+1):'0'+((parseInt(selected_building.max_floor)-fl)+1)) ? 'orange lighten-3':'')+' pa-2 text-center'"

                                                            style="border-bottom: 1px solid #ccc;border-top: 1px solid #ccc;font-size: 0.85em;"
                                                    >
                                                        <span v-if="((parseInt(selected_building.max_floor)-fl)+1)!=13">
                                                            {{ ((parseInt(selected_building.max_floor)-fl)+1)>9 ? ((parseInt(selected_building.max_floor)-fl)+1):"0"+((parseInt(selected_building.max_floor)-fl)+1) }}
                                                        </span>
                                                        <span v-else>
                                                                12A
                                                        </span>
                                                    </v-col>
                                                </template>
                                            </div>
                                        </v-card>
                                        <div class="text-center scrollable" @click="scrollFloor('down')">
                                            <v-icon>mdi-menu-down</v-icon>
                                        </div>
                                    </div >
                                    <div style="margin-left: 42px;">
                                        <div class="body-floor-plan" :style="planStyle">
                                            <div class="d-flex flex-row">
                                                <!-- ซ้าย -->
                                                <div class="white lighten-2 view_border_right" style="min-width: 150px;"></div>

                                                <div class="d-flex flex-column">
                                                    <!-- บน -->
                                                    <div class="d-flex justify-center align-center white lighten-2 view_border_bottom" style="min-height: 150px;"></div>

                                                    <!-- แปลน  -->
                                                    <div class="cover-img" :style="(original_plan_img_size&&original_plan_img_size.
                                                     width>0 ? 'width:'+original_plan_img_size.width+'px;'+'height:'+original_plan_img_size.height+'px;':'')">
                                                        <v-img id="img-floor-plan"
                                                               :src="(plan_mapping ? plan_mapping.SP_PLAN_BG:'')"
                                                               :lazy-src="(plan_mapping ? plan_mapping.SP_PLAN_BG:'')"
                                                        >
<!--                                                            @load="loadMappingUnit(selected_floor)"-->
                                                            <template v-slot:placeholder>
                                                                <v-row
                                                                        class="fill-height ma-0"
                                                                        align="center"
                                                                        justify="center"
                                                                >
                                                                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                                                </v-row>
                                                            </template>
                                                        </v-img>

                                                        <template v-if="unit_list_mapping" v-for="(unit_data, unit_index) in unit_list_mapping">
                                                            <div v-if="unit_data.available_status&&planStyle_zoom>0.29"
                                                                 :class="'d-flex align-center justify-center location-pin allowed '+(unit_data.TEXT_POSITION=='B' ? 'flex-column ':'')+(unit_data.is_favorite&&unit_data.is_favorite=='Y' ? ' is_favorite':'')"
                                                                 :pd="unit_data.PD_RUNNO"
                                                                 :id="'NO_'+unit_data.PD_RUNNO"
                                                                 :style="'top:'+unit_data.SM_POSITION_Y+'px;left:'+unit_data.SM_POSITION_X+'px;'+unit_data.MARGIN_FIXED+(unit_data.is_favorite&&unit_data.is_favorite=='Y' ? 'border: 1px solid #2196f3 !important;':'')"
                                                                 @click="showDetail(unit_data)"
                                                            >
                                                                <template v-if="unit_data.TEXT_POSITION=='B'">
                                                                    <div v-if="planStyle_zoom>0.29" class="stock_no_cover flex-fill white">
                                                                        <div class="d-flex align-center justify-center" :style="'width: '+(plan_config.BAAN_ICON_SIZE ? plan_config.BAAN_ICON_SIZE:40)+'px;height: '+(plan_config.BAAN_ICON_SIZE ? plan_config.BAAN_ICON_SIZE:40)+'px;border-radius: 5px;background-color: '+unit_data.hot_color+';'">
                                                                            <div class="text-center white--text">
                                                                                <div class="text-center stock_no text-lpn d-flex align-center" :style="stockStyle">
                                                                                    <v-icon small v-if="unit_data.is_favorite&&unit_data.is_favorite=='Y'" color="blue" style="float:left;">
                                                                                        mdi-star
                                                                                    </v-icon>
                                                                                    <span>
                                                                                        {{ unit_data[plan_config.BAAN_ICON_TEXT_FIELD] }}
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div v-if="planStyle_zoom>0.59" class="mt-1 flex-fill" :style="unit_data.TEXT_MARGIN">
<!--                                                                        <div class="text-center stock_no text-lpn">-->
<!--                                                                            {{ unit_data[plan_config.BAAN_ICON_TEXT_FIELD] }}-->
<!--                                                                        </div>-->
                                                                        <div v-if="planStyle_zoom>0.59" class="detail_status justify-center d-flex flex-column" :style="stockStyle">
                                                                            <div v-if="parseFloat(unit_data.price_total_amount)>0&&(unit_data.hasOwnProperty('property_is_open_for_sale')&&unit_data.property_is_open_for_sale=='Y')" style="">
                                                                                {{(parseFloat(unit_data.price_total_amount))/1000000   | formatNumber3Digit}}
                                                                            </div>
                                                                            <div class="blue--text text--accent-2" style="border-top: 1px solid #ccb5b5!important;">{{ unit_data.property_area }}</div>
                                                                        </div>
                                                                    </div>

                                                                </template>
                                                                <template v-else-if="unit_data.TEXT_POSITION=='R'">
                                                                    <div v-if="planStyle_zoom>0.29" class="stock_no_cover flex-fill white">
                                                                        <div class="d-flex align-center justify-center" :style="'min-width: '+(plan_config.BAAN_ICON_SIZE ? plan_config.BAAN_ICON_SIZE:40)+'px;height: '+(plan_config.BAAN_ICON_SIZE ? plan_config.BAAN_ICON_SIZE:40)+'px;border-radius: 5px;background-color: '+unit_data.hot_color+';'">
                                                                            <div class="text-center white--text">
                                                                                <div class="text-center stock_no text-lpn d-flex align-center" :style="stockStyle">
                                                                                    <v-icon small v-if="unit_data.is_favorite&&unit_data.is_favorite=='Y'" color="blue" style="float:left;">
                                                                                        mdi-star
                                                                                    </v-icon>
                                                                                    <span>
                                                                                        {{ unit_data[plan_config.BAAN_ICON_TEXT_FIELD] }}
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div v-if="planStyle_zoom>0.59" class="ml-1 flex-fill" :style="unit_data.TEXT_MARGIN">
<!--                                                                        <div class="text-center stock_no text-lpn">-->
<!--                                                                            {{ unit_data[plan_config.BAAN_ICON_TEXT_FIELD] }}-->
<!--                                                                        </div>-->
                                                                        <div v-if="planStyle_zoom>0.59" class="detail_status justify-center d-flex flex-column" :style="stockStyle">
                                                                            <div v-if="parseFloat(unit_data.price_total_amount)>0&&(unit_data.hasOwnProperty('property_is_open_for_sale')&&unit_data.property_is_open_for_sale=='Y')" style="">
                                                                                {{(parseFloat(unit_data.price_total_amount))/1000000   | formatNumber3Digit}}
                                                                            </div>
                                                                            <div class="blue--text text--accent-2" style="border-top: 1px solid #ccb5b5!important;">{{ unit_data.property_area }}</div>
                                                                        </div>
                                                                    </div>
                                                                </template>
                                                            </div>
                                                            <div v-else-if="planStyle_zoom>0.29"
                                                                 class="location-pin"
                                                                 :pd="unit_data.PD_RUNNO"
                                                                 :id="'NO_'+unit_data.PD_RUNNO"
                                                                 :style="'top:'+unit_data.SM_POSITION_Y+'px;left:'+unit_data.SM_POSITION_X+'px;'"
                                                            >
                                                                <div v-if="planStyle_zoom>0.29"  class="stock_no_cover sold_cover">
                                                                    <div class="stock_no sold_text" :style="stockStyle">
<!--                                                                        <v-icon color="red" class="text&#45;&#45;accent-4">mdi-lock</v-icon>-->
                                                                        <span class="red--text text--accent-4 font-weight-bold">SOLD</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div v-else
                                                                 class="location-pin"
                                                                 :pd="unit_data.PD_RUNNO"
                                                                 :id="'NO_'+unit_data.PD_RUNNO"
                                                                 :style="'top:'+unit_data.SM_POSITION_Y+'px;left:'+unit_data.SM_POSITION_X+'px;'"
                                                            >
                                                                <div class="stock_no_cover number_cover">
                                                                    <div class="stock_no number_text" :style="stockStyle">
                                                                        <span v-if="unit_data.available_status">
                                                                            {{ unit_data[plan_config.BAAN_ICON_TEXT_FIELD] }}
                                                                        </span>
                                                                        <span v-else>
                                                                            <v-icon color="red" class="text--accent-4">mdi-lock</v-icon>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </template>
                                                    </div>
                                                    <!-- ล่าง -->
                                                    <div class="white lighten-2 view_border_top" style="min-height: 150px;"></div>
                                                </div>
                                                <!-- ขวา -->
                                                <div class="white lighten-2 view_border_left" style="min-width: 150px;"></div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
                <div v-else id="content_error">
                    <v-layout wrap align-center justify-center>
                        <v-flex  xs12 sm12 md12 style="text-align: left" class="mt-4">
                            <v-alert
                                    :value="true"
                                    outlined
                                    type="error"
                                    class=""
                            >
                                <span>ขออภัยค่ะ ไม่พบรายการที่ท่านเลือก</span>
                            </v-alert>
                        </v-flex>
                    </v-layout>
                </div>
                <div class="plan_footer"></div>

                <v-overlay v-if="overall_image" :value="overlay2" :opacity="0.8">
                    <div @click="overlay2=false" class="close_fullcsreen_slide" style="position: absolute;right:10px;z-index: 9999;top:-30px;">
                        Close<v-icon right>mdi-close</v-icon>
                    </div>
                    <div class="text-center" id="overall_plan">
                        <v-img :src="overall_image" style="max-width: 100%;max-height: 90vh;"/>
                    </div>
                </v-overlay>

            </div>
        </div>
</template>

<script>

    import numeral from 'numeral'

    export default {
        name: "FloorPlan",
        components:{
        },
        props: {
            show: {type: Boolean, default: false},
            project_code: {type: String, default: ''},
            project_id: {type: String, default: ''},
            campaign_id: {type: [Number, String], default: ''},
            plan_type: {type: String, default: 'sale_stock'},
            unit: {type: Array, default: []},
            updated_unit: {type: Object, default: null},
            option:{type: Object, default: null}
        },
        data() {
            return {
                current_loading_state:{
                    show:false,
                    message:'กำลังโหลดข้อมูล....กรุณารอสักครู่.',
                    progressColor:'blue'
                },
                image_size_list:[],
                original_plan_img_size:null,
                isLoading: true,
                onRenderCanvas:false,
                plan_config:null,
                stock_mapping:null,
                plan_mapping:null,
                size_color:null,
                hot_color: [
                    {
                        order:1,
                        score:0,
                        color_code:"#e7f5ae",
                        color_text:"#000",
                    },
                    {
                        order:2,
                        score:9999,
                        color_code:"#fee4a3",
                        color_text:"#000",
                    },
                    {
                        order:3,
                        score:9999,
                        color_code:"#fdb16c",
                        color_text:"#000",
                    },
                    {
                        order:4,
                        score:9999,
                        color_code:"#ee7a48",
                        color_text:"#fff",
                    },
                    {
                        order:5,
                        score:9999,
                        color_code:"#dd472f",
                        color_text:"#fff",
                    },
                    {
                        order:6,
                        score:9999,
                        color_code:"#e80003",
                        color_text:"#fff",
                    }
                ],
                room_direction:null,
                unit_list:null,
                unit_list_mapping:null,
                hideBlank:false,
                overlay2: false,
                overall_image:'',
                building_config:null,
                selected_building:null,
                selected_floor:null,

                score_list:null,
                display_option:{
                    display_field:{
                        field_name:'PD_CODE',
                    },
                    show_lock:true,
                    show_title:true,
                    style:{
                        td_width:"50px",
                        td_height:"60px",
                    },
                },
                planStyle_zoom:0.3,
                plan_position_x:0,
                stockNoFontSize:1.05,
                stockDetailsFontSize:0.6,
                stockSoldFontSize:0.85,
                planZoomToolBottom:110,
            }
        },
        watch: {
            async updated_unit(v){
                // console.log("plan updated",v)
                if(v){
                    let tmp = []
                    // this.unit_list_mapping = [...await this.mappingUnitFavorite( this.unit_list_mapping)]
                    await this.unit_list_mapping.forEach((data,key) =>{
                        if(data.property_id==v.property_id){
                            if(v.hasOwnProperty('is_favorite')){
                                data.is_favorite = v.is_favorite
                            }
                        }
                        tmp.push(data)
                    })
                    this.unit_list_mapping = [...tmp]
                }
            },
            async selected_building(){
                // console.log("bd")
                if(this.selected_floor) {
                    // this.plan_mapping = null
                    this.plan_mapping = await this.getPlanMapping(this.selected_floor)
                    this.unit_list_mapping = null
                    this.original_plan_img_size = await this.getOriginalWidthOfImg(this.selected_floor)
                    if (this.unit && this.unit.length > 0) {
                        this.unit_list = [...this.unit]
                        this.unit_list_mapping = [...await this.mappingUnitData(this.unit_list)]
                    }
                }
            },
            async selected_floor(v){
                // console.log("fl")
                // this.plan_mapping = null
                this.plan_mapping = await this.getPlanMapping(v)
                this.unit_list_mapping = null
                this.original_plan_img_size = await this.getOriginalWidthOfImg(v)
                if(this.unit&&this.unit.length>0){
                    this.unit_list = [...this.unit]
                    this.unit_list_mapping = [...await this.mappingUnitData(this.unit_list)]
                }
            },
            overlay2(val) {
                if (val) {
                    document.addEventListener('mousedown', this.mousedownHandler)
                } else {
                    document.removeEventListener('mousedown', this.mousedownHandler)
                }
            }
        },
        async created(){
            window.addEventListener('scroll', this.pageScrollHandler)

            this.plan_config = await this.getPlanSetting()
            // console.log(this.plan_config)

            if(this.plan_config) {

                this.building_config = await this.getBuildingSetting()
                if(this.building_config&&this.building_config.length>0) {
                    this.selected_building = this.building_config[0]
                    this.size_color = JSON.parse(this.building_config[0].SizeColor)
                }

                this.stock_mapping = await this.getStockMapping()
                this.image_size_list = await this.getPlanMapping().then((all_pm) => {
                    let image_size_list_tmp = []
                    Object.entries(all_pm).forEach(async (value,key) => {
                        const img = await new Image()
                        img.src = all_pm[key].SP_PLAN_BG
                        img.onload = () => {
                            if(img) {
                                image_size_list_tmp.push({
                                    floor_no: all_pm[key].SP_FLOOR_NO,
                                    size: {width: img.width, height: img.height}
                                })
                            }
                        }
                        // console.log(img)
                    })

                    return image_size_list_tmp
                })
                    .then(()=>{
                        let max_start_floor = 1
                        this.building_config.forEach((value,key) => {
                            if(parseInt(value.floor_start)>max_start_floor){
                                max_start_floor = parseInt(value.floor_start)
                            }
                        })
                        // this.selected_floor = this.building_config[0].floor_start>9 ? this.building_config[0].floor_start:'0'+this.building_config[0].floor_start
                        this.selected_floor = max_start_floor>9 ? max_start_floor:'0'+max_start_floor
                })

                //set dynamic font-size
                const icon_size = parseInt(this.plan_config ? this.plan_config.BAAN_ICON_SIZE:40)
                this.stockNoFontSize = (icon_size*2.625)/100
                this.stockDetailsFontSize = (icon_size*1.25)/100
                this.stockSoldFontSize = (icon_size*2.125)/100
            }

            if(this.option){
                this.display_option = this.option
            }

            // this.reCheckCartItem()
            // if(this.current_cart_item.length>0){
            //     this.planZoomToolBottom = 110
            // }
        },
        destroyed () {
            window.removeEventListener('scroll', this.pageScrollHandler)
        },
        async mounted(){
            // console.log(this.toolStyle)
        },
        computed: {
            planStyle () {
                return {
                    '--zoom-amount': this.planStyle_zoom
                }
            }
            ,stockStyle () {
                return {
                    '--stock-no-font-size': this.stockNoFontSize+'rem',
                    '--details-font-size': this.stockDetailsFontSize+'rem',
                    '--sold-font-size': this.stockSoldFontSize+'rem',
                }
            },
            toolStyle () {
                return {
                    '--bottom-zoom-tool': this.planZoomToolBottom+'px'
                }
            }
        },
        methods:{
            async loadMappingUnit(x){
                this.original_plan_img_size = await this.getOriginalWidthOfImg(x)
                if (this.unit && this.unit.length > 0) {
                    this.unit_list = [...this.unit]
                    this.unit_list_mapping = [...await this.mappingUnitData(this.unit_list)]
                }

                // console.log("set",this.plan_position_x)
                //
                // const base_elem = this.$el.querySelector('.plan-table-detail')
                // if(base_elem) {
                //     base_elem.scrollLeft = this.plan_position_x
                // }

            },
            mousedownHandler(e) {
                if (e.target.classList.contains('v-overlay__scrim')){
                    this.overlay2 = false
                }
            },
            pageScrollHandler(e) {
                if (e){
                    let aa = this.$el.querySelectorAll('.select_floor')
                    let bb = this.$el.querySelector('.plan-building-name')
                    let cc = this.$el.querySelector('.zoom_tool')
                    let bd_name_text = this.$el.querySelector('.bd_name_text')
                    let bd_name_select = this.$el.querySelector('.bd_name_select')
                    let base_elem = this.$el.querySelector('.plan-table-detail')
                    let scroll_tool = this.$el.querySelectorAll('.scrollable')
                    if(base_elem) {
                        let base_position = base_elem.getBoundingClientRect()
                        for (let i = 0; i < aa.length; ++i) {
                            if (base_position) {
                                if (base_position.top-150 < 52) {
                                    // console.log("<")
                                    aa[i].classList.add('fixed_left');
                                    bb.classList.add('fixed_left','float_building_name','elevation-10');
                                    cc.classList.add('fixed_left','float_zoom_tool','elevation-10');
                                    bd_name_text.classList.add('d-none');
                                    bd_name_select.classList.remove('d-none');

                                    scroll_tool[0].classList.remove('d-none');
                                    scroll_tool[1].classList.remove('d-none');
                                } else {
                                    // console.log(">")
                                    aa[i].classList.remove('fixed_left');
                                    bb.classList.remove('fixed_left','float_building_name','elevation-10');
                                    cc.classList.remove('fixed_left','float_zoom_tool','elevation-10');
                                    scroll_tool[0].classList.add('d-none');
                                    scroll_tool[1].classList.add('d-none');

                                    bd_name_text.classList.remove('d-none');
                                    bd_name_select.classList.add('d-none');
                                }
                            }
                        }
                    }
                }
            },
            // savePosition(){
            //     let table_details = this.$el.querySelector('.plan-table-detail')
            //     this.plan_position_x = table_details.scrollLeft
            //     console.log("save",this.plan_position_x)
            // },
            scrollFloor(di){
                let base_elem = this.$el.querySelector('.floor_number')
                if(base_elem) {
                    if(di=='down') {
                        base_elem.scrollTop += 100
                    }else{
                        base_elem.scrollTop -= 100
                    }
                }
            },
            async getOriginalWidthOfImg(floor_number) {
                const img = new Image()
                img.src =  await this.plan_mapping.SP_PLAN_BG

                // console.log(img.src)
                // console.log("first",{width: img.width, height: img.height})

                if(img) {
                    if(img.width==0){
                        img.height=1812
                        img.width=1500
                    }
                    return {width: img.width, height: img.height}
                }else{
                    return false
                }
            },
            async checkUnitMapping(ref1){
                if(this.stock_mapping.length>0) {
                    let tmp_pp = this.stock_mapping.find(t =>
                        t.PD_RUNNO === ref1
                    )
                    return tmp_pp
                }
                return false
            },
            checkScoreUnit(property_id){
                if(this.score_list.length>0) {
                    // console.log(property_id)
                    let score = Object.entries(this.score_list).find(t =>
                        t[1].property_id === property_id
                        // true
                    )
                    if(typeof(score) !== 'undefined' && score !== null){
                        // let summary = JSON.parse(JSON.stringify(score[1])).score_summary
                        let summary = JSON.parse(JSON.stringify(score[1])).rank
                        return summary
                    }
                }
                return 0
            },
            async mappingUnitData(ul){
                let px,py,wPercent,hPercent, x, y = 0;
                let h = this.original_plan_img_size.height;
                let w = this.original_plan_img_size.width;
                wPercent = w/100;
                hPercent = h/100;
                let temp_properties_list = []
                let tmp_mapping_unit = {}
                let fv = null

                this.score_list = await this.getPropertyScoreList()

                fv = await this.getFavoriteDetail()

                if(ul&&ul.length>0) {
                    // console.log('start',ul)
                    // console.log('plan',this.plan_mapping)
                    ul.forEach(async (data, key) => {
                        if(this.plan_mapping&&
                            (this.plan_mapping.PJ_CODE==data.project_code&&this.plan_mapping.SP_BUILD_NO==data.building_code
                                &&(this.plan_mapping.SP_FLOOR_NO==data.property_floor
                                    ||(parseInt(this.plan_mapping.SP_FLOOR_NO)==13 ? '12A':parseInt(this.plan_mapping.SP_FLOOR_NO))==parseInt(data.property_floor)||(parseInt(this.plan_mapping.SP_FLOOR_NO)==13 ? '12A':this.plan_mapping.SP_FLOOR_NO)==data.property_floor)
                            )
                        ) {


                            tmp_mapping_unit = await this.checkUnitMapping(data.PD_RUNNO)
                            // data.hit_score = this.checkScoreUnit(data.property_id)
                            data.score_range = this.checkScoreUnit(data.property_id)

                            // tmp_hot_color = this.hot_color.find((c)=>{
                            //     return c.score >= data.hit_score
                            // })

                            // data.hot_color = tmp_hot_color ? tmp_hot_color.color_code:this.hot_color[5].color_code
                            // data.hot_text = tmp_hot_color ? tmp_hot_color.color_text:this.hot_color[5].color_text
                            data.hot_color = data.score_range ? this.hot_color[parseInt(data.score_range)-1].color_code:this.hot_color[0].color_code
                            data.hot_text = data.score_range ? this.hot_color[parseInt(data.score_range)-1].color_text:this.hot_color[0].color_text

                            px = parseInt(tmp_mapping_unit.SM_POSITION_X) - ((parseInt(this.plan_config.BAAN_ICON_SIZE ? this.plan_config.BAAN_ICON_SIZE : '40') * 60) / 100)
                            py = parseInt(tmp_mapping_unit.SM_POSITION_Y) - ((parseInt(this.plan_config.BAAN_ICON_SIZE ? this.plan_config.BAAN_ICON_SIZE : '40') * 25) / 100)

                            x = parseInt(((px / w) * 100) * wPercent) + 5
                            y = parseInt(((py / h) * 100) * hPercent) - 15

                            // console.log(tmp_mapping_unit)


                            data.SM_POSITION_X = x
                            data.SM_POSITION_Y = y
                            data.TEXT_POSITION = tmp_mapping_unit.TEXT_POSITION ? tmp_mapping_unit.TEXT_POSITION : 'B'
                            data.MARGIN_FIXED = tmp_mapping_unit.MARGIN_FIXED
                            data.TEXT_MARGIN = tmp_mapping_unit.TEXT_MARGIN
                            data.PD_RUNNO = tmp_mapping_unit.PD_RUNNO
                            data.PD_CODE = tmp_mapping_unit.PD_CODE
                            data.PD_ROOM = tmp_mapping_unit.PD_ROOM

                            if (fv.length > 0) {
                                let found_fv = fv.find(t =>
                                    t.property_id === data.property_id
                                )
                                if(found_fv){
                                    data.is_favorite = 'Y'
                                }else{
                                    data.is_favorite = 'N'
                                }
                            }else{
                                data.is_favorite = 'N'
                            }

                            // console.log("...finish mapping data",data)
                            temp_properties_list.push(data)
                        }
                    })
                }
                // console.log(temp_properties_list)

                return temp_properties_list
            },
            async getPropertyScoreList(){
                const requestBody = {
                    project_id:this.project_id,
                    user_id:this.getAppUserId(),
                    type:1
                }
                let promiseChecking, finalResult = []

                promiseChecking = await this.promiseHandle(this.PostHttp('Readytomove/getPropertyScoreList', requestBody,false,'json','rms'))

                if (!promiseChecking.error) {
                    if (promiseChecking.result.status=='success'&&promiseChecking.result.res.data.code == '000') {
                        finalResult = [...promiseChecking.result.res.data.result]
                    }
                }

                return finalResult
            },
            getColor(area){
                let result_color = '#ffffff'
                if(area){
                    let area_multiply = area * 100
                    let area_compare = 0
                    let loopstop = false
                    if(this.size_color){
                        Object.entries(this.size_color).reverse().forEach((data, key) => {
                            area_compare = parseFloat(data[0])
                            if(area_multiply>=area_compare&&!loopstop){
                                result_color = data[1][0]
                                loopstop = true
                                // console.log(result_color)
                            }
                        });
                    }
                }
                return result_color
            },
            zoomOut () {
                this.planStyle_zoom = (this.planStyle_zoom - 0.1) || 0.2
            },
            zoomIn () {
                this.planStyle_zoom = (this.planStyle_zoom + 0.1) || 1
            },
            async setSelectedBuilding(bd){
                if(bd) {
                    this.selected_building = bd
                }else{
                    this.selected_building = null
                }
            },
            setSelectedFloor(fl){
                if(fl) {
                    this.selected_floor = fl
                    // if(fl!=13) {
                    //     this.selected_floor = fl
                    // }else{
                    //     this.selected_floor = '12A'
                    // }
                }else{
                    this.selected_floor = null
                }
            },
            showDetail(unit_data){
                if(unit_data&&unit_data.hasOwnProperty('PD_RUNNO')) {
                    // console.log(unit_data)
                    this.$emit('togglePlanDetailDialog', {show:true,unit_data:unit_data});
                }
            },
            reFormatNumber(value,format){
                return value&&value!=0 ? numeral(value).format(format):''
            },
            getDirectionName(direction_code){
                let direction_name = ''
                if (direction_code == 'N') direction_name = "ทิศเหนือ"
                if (direction_code == 'E') direction_name = "ทิศตะวันออก"
                if (direction_code == 'S') direction_name = "ทิศใต้"
                if (direction_code == 'W') direction_name = "ทิศตะวันตก"
                if (direction_code == 'NW') direction_name = "ทิศตะวันตกเฉียงเหนือ"
                if (direction_code == 'NE') direction_name = "ทิศตะวันออกเฉียงเหนือ"
                if (direction_code == 'SE') direction_name = "ทิศตะวันออกเฉียงใต้"
                if (direction_code == 'SW') direction_name = "ทิศตะวันตกเฉียงใต้"
                return direction_name
            },
            async getPlanSetting(){
                const requestBody = {
                    pj_code:this.project_code,
                    plan_type:this.plan_type
                }
                let promiseChecking, finalResult = []

                promiseChecking = await this.promiseHandle(this.PostHttp('salePlan/config/getPlanSetting', requestBody,false,'json','rms'))

                if (!promiseChecking.error) {
                    if (promiseChecking.result.status=='success'&&promiseChecking.result.res.data.code == '000') {
                        finalResult = {...promiseChecking.result.res.data.result}
                        if(this.isEmptyObj(finalResult)){
                            finalResult = null
                        }
                    }
                }

                return finalResult
            },
            async getBuildingSetting(){
                const requestBody = {
                    pj_code:this.project_code,
                    plan_type:this.plan_type
                }
                let promiseChecking, finalResult = []

                promiseChecking = await this.promiseHandle(this.PostHttp('salePlan/config/getBuildingSetting', requestBody,false,'json','rms'))

                if (!promiseChecking.error) {
                    if (promiseChecking.result.status=='success'&&promiseChecking.result.res.data.code == '000') {
                        finalResult = [...promiseChecking.result.res.data.result]
                    }
                }

                return finalResult
            },
            async getPlanMapping(floor_no){
                // console.log("gen map")
                const requestBody = {
                    pj_code:this.project_code,
                    bd_runno:(this.selected_building ? this.selected_building.bd_runno:''),
                    floor_no:floor_no
                }
                let promiseChecking, finalResult = []

                promiseChecking = await this.promiseHandle(this.PostHttp('salePlan/config/getPlanMapping', requestBody,false,'json','rms'))

                if (!promiseChecking.error) {
                    if (promiseChecking.result.status=='success'&&promiseChecking.result.res.data.code == '000') {
                        if(floor_no) {
                            finalResult = {...promiseChecking.result.res.data.result}
                        }else {
                            finalResult = {...promiseChecking.result.res.data.result}
                        }
                    }
                }


                return finalResult
            },
            async getStockMapping(){
                const requestBody = {
                    pj_code:this.project_code,
                    plan_type:this.plan_type
                }
                let promiseChecking, finalResult = []

                promiseChecking = await this.promiseHandle(this.PostHttp('salePlan/config/getStockMapping', requestBody,false,'json','rms'))

                if (!promiseChecking.error) {
                    if (promiseChecking.result.status=='success'&&promiseChecking.result.res.data.code == '000') {
                        finalResult = [...promiseChecking.result.res.data.result]
                    }
                }

                return finalResult
            },
            switchPlanMode(mode,pj_id){
                // console.log(mode,pj_id,this.campaign_id)
                if(mode=='table'){
                    this.gotoRoute('saleOnline_salePlanSaleEvent',{project_id:pj_id,camp:this.campaign_id})
                }
            }
        }
    }
</script>

<style scoped>
    .select_building{
        cursor: pointer;
    }

    .plan-table-detail{
        overflow-x: scroll;
    }
    .plan-table-detail.on-canvas{
        overflow-x: visible !important;
        overflow: visible !important;
    }

    #overall_plan{
        max-width: 100vw;
        max-height: 100vh;
    }

    .body-floor-plan{
        width: 100%;
        max-height: 100%;
        margin-right: auto;
        margin-left: auto;
        zoom: var(--zoom-amount);
        -webkit-text-size-adjust: auto;
    }
    .cover-img{
        /*width:4000px;*/
        position:relative;
    }

    .cover-img #img-floor-plan{
        width:100%;
        height: 100%;
    }

    .location-pin{
        position:absolute;
        z-index:2;
        -webkit-text-size-adjust: auto;
    }

    .stock_no{
        text-align: center;
        font-weight: bold;
        font-size: var(--stock-no-font-size);
        color: #28317e;
        background: transparent;
        box-shadow: none;
        text-shadow: -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff;
        -webkit-text-size-adjust: auto;
        padding: 0.3rem 0;
    }

    .stock_no_cover .stock_no:hover{
        /*cursor: pointer;*/
        /*background: #fff5a4 !important;*/
        /*box-shadow: 1px 1px 1px #533f03 !important;*/
    }

    /*.location-pin.allowed:hover{*/
    .location-pin.allowed{
        cursor: pointer;
        border: 1px solid #fff !important;
        background: #ffffff !important;
        border-radius: 5px;
        padding: 2px;
        /*box-shadow: 1px 1px 1px #533f03 !important;*/
    }

    .location-pin.allowed.is_favorite{
        /*border: 1px solid #ffffff !important;*/
        /*background: #fcf412 !important;*/
        /*box-shadow: 1px 1px 20px #fcf412 !important;*/
        /*box-shadow: 1px 1px 20px #16448f  !important;*/
    }

    .detail_status {
        font-size: var(--details-font-size);
        color: #555;
        font-weight: bold;
        text-shadow: -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff;
        text-align: center;
        -webkit-text-size-adjust: auto;
    }
    .detail_status  div{
        -webkit-text-size-adjust: auto;
        font-size: var(--details-font-size);
    }

    .sold_cover {
        text-align: center;
        font-weight: bold;
        font-size: var(--stock-no-font-size);
        color: #d60303;
        background: transparent;
        box-shadow: none;
        text-shadow: -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff;
        -webkit-text-size-adjust: auto;
        padding: 0.3rem 0;
    }
    .sold_text {
        font-size: var(--sold-font-size) !important;
        color: #d60303;
    }

    .number_cover {
        text-align: center;
        font-weight: bold;
        font-size: var(--stock-no-font-size);
        color: #16448f;
        background: transparent;
        box-shadow: none;
        text-shadow: -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff;
        -webkit-text-size-adjust: auto;
        margin-top: -0.35rem;
    }
    .number_text {
        font-size: var(--sold-font-size) !important;
        color: #16448f;
    }

    .select_floor{
        position: absolute;
        z-index: 3;
    }
    .fixed_left{
        position: fixed;
        top:52px;
        left:0;
        z-index: 3;
    }

    .float_building_name{
        /*font-size: 1rem;*/
        font-size: 0.85rem;
        margin-top: 5px;
        color: #555;
        background-color: #ffffff;
        text-shadow: -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff;
        /*box-shadow: 1px 2px 10px #888 !important;*/
        border-radius: 5px;
        /*padding: 2px 5px;*/
        left: unset !important;
        right:10px !important;
    }


    .float_zoom_tool{
        font-size: 0.85rem;
        color: #00acc1;
        background-color: #ffffff;
        text-shadow: -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff;
        border-radius: 5px;
        padding: 2px 5px;
        left: unset !important;
        min-width: 150px;
        right: 10px !important;
        max-height: 35px;
        bottom: var(--bottom-zoom-tool) !important;
        top: unset;
    }

    .fixed_left .floor_number{
        max-height: 50vh;
        overflow-y: scroll;
    }
    .floor_number::-webkit-scrollbar{
        width: 0px;
        background: transparent;
    }
    .floor_number div{
        cursor: pointer;
    }

    .floor_number div:hover{
        background-color: #f0f0f0;
    }

    .scrollable{
        cursor: pointer;
    }

    .rotate_left_90{
        width:100%;
        display:inline-block;
        transform: rotate(-90deg);
        -webkit-transform: rotate(-90deg);
        -moz-transform: rotate(-90deg);
        -ms-transform: rotate(-90deg);
        -o-transform: rotate(-90deg);
        text-align:center;
        margin-top: 420px;
    }

    .rotate_right_90{
        width:100%;
        display:inline-block;
        transform: rotate(90deg);
        -webkit-transform: rotate(90deg);
        -moz-transform: rotate(90deg);
        -ms-transform: rotate(90deg);
        -o-transform: rotate(90deg);
        text-align:center;
        margin-bottom: 420px;
    }

    .rotate_180{
        width:100%;
        display:inline-block;
        transform: rotate(-180deg);
        -webkit-transform: rotate(-180deg);
        -moz-transform: rotate(-180deg);
        -ms-transform: rotate(-180deg);
        -o-transform: rotate(-180deg);
        text-align:center;
    }

    .view_border_left{
        border-left: 1px solid #16448f !important;
    }

    .view_border_right{
        border-right: 1px solid #16448f !important;
    }

    .view_border_bottom{
        border-bottom: 1px solid #16448f !important;
        border-left: 2px solid #fff;
        border-right: 2px solid #fff;
        margin-left: -4px;
        margin-right: -4px;
        background: #fff;
        z-index: 1;
    }

    .view_border_top{
        border-top: 1px solid #16448f !important;
        border-left: 2px solid #fff;
        border-right: 2px solid #fff;
        margin-left: -4px;
        margin-right: -4px;
        background: #fff;
        z-index: 1;
    }

    .float_building_name .bd_name_select{
        margin-top: 0 !important;
        text-shadow:none;
        color:#cccccc !important;
    }
    .float_building_name .bd_name_select{
        border-radius: 5px;
    }
    .float_building_name .bd_name_select .select_building{
        background-color: #fff !important;
        border:1px solid #ccc;
    }

</style>
